import { motion } from 'framer-motion';
import RealEstatesCard from './RealEstatesCard';

export default function RealEstatesGrid({
  items,
  realEstateTypes,
  currentPage,
  totalPages,
  onPageChange,
}) {
  const getRealEstateTypeName = (realEstate) => {
    if (realEstate.realEstateType?.name) {
      return realEstate.realEstateType.name;
    }

    if (realEstate.realEstateTypeName) {
      return realEstate.realEstateTypeName;
    }

    if (typeof realEstate.realEstateType === 'string') {
      return realEstate.realEstateType;
    }

    const matchingType = realEstateTypes?.find(
      (type) => type.id === realEstate.realEstateTypeId
    );

    return matchingType?.name ?? '';
  };

  return (
    <>
      {items.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-8 pb-12 pt-6">
          {items.map((realEstate, index) => {
            const realEstateTypeName = getRealEstateTypeName(realEstate);
            const isLot = realEstateTypeName.toLowerCase().includes('lote');

            return (
              <motion.div
                key={realEstate.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{
                  duration: 0.5,
                  delay: 0.2 + index * 0.1,
                  ease: 'easeOut',
                }}
              >
                <RealEstatesCard
                  id={realEstate.id}
                  coverImageUrl={realEstate.coverImageUrl}
                  name={realEstate.name}
                  businessType={realEstate.businessType}
                  isLot={isLot}
                  area={realEstate.area}
                  city={realEstate.city}
                  sector={realEstate.sector}
                  garage={realEstate.garage}
                  price={realEstate.price}
                  bedrooms={realEstate.bedrooms}
                  bathrooms={realEstate.bathrooms}
                  createdAt={realEstate.createdAt}
                />
              </motion.div>
            );
          })}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center h-[80vh] text-center pt-12 pb-20">
          <img
            src="/NoResults.png"
            alt="No results found"
            className="h-72 w-72"
          />
          <p className="text-lg text-customBlue font-bold tracking-tight">
            No se encontraron resultados
          </p>
        </div>
      )}

      {/* Paginador */}
      {totalPages > 1 && (
        <nav
          aria-label="Page navigation example"
          className="flex justify-center pb-8"
        >
          <ul className="flex items-center -space-x-px h-8 text-sm">
            <li>
              <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="flex items-center justify-center transition-colors duration-500 px-3 h-8 ms-0 leading-tight text-gray-500 bg-white border border-e-0 border-gray-300 rounded-s-lg hover:bg-gray-200 hover:text-gray-700 disabled:opacity-50"
              >
                <span className="sr-only">Previous</span>
                <svg
                  className="w-2.5 h-2.5 rtl:rotate-180"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 6 10"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 1 1 5l4 4"
                  />
                </svg>
              </button>
            </li>
            {Array.from({ length: totalPages }, (_, index) => (
              <li key={index}>
                <button
                  onClick={() => onPageChange(index + 1)}
                  className={`flex items-center justify-center transition-colors duration-500 px-3 h-8 leading-tight ${
                    currentPage === index + 1
                      ? 'border border-customBlue text-customBlue bg-blue-50 hover:bg-blue-100 hover:text-customBlue font-bold'
                      : 'text-gray-500 bg-white border border-gray-300 hover:bg-gray-200 hover:text-gray-900'
                  }`}
                  aria-current={currentPage === index + 1 ? 'page' : undefined}
                >
                  {index + 1}
                </button>
              </li>
            ))}
            <li>
              <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="flex items-center justify-center transition-colors duration-500 px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-e-lg hover:bg-gray-200 hover:text-gray-700 disabled:opacity-50"
              >
                <span className="sr-only">Next</span>
                <svg
                  className="w-2.5 h-2.5 rtl:rotate-180"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 6 10"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 9 4-4-4-4"
                  />
                </svg>
              </button>
            </li>
          </ul>
        </nav>
      )}
    </>
  );
}
